var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-upload',{ref:"upload",staticClass:"upload-demo",attrs:{"action":"#","accept":'jpg,jpeg,png',"show-file-list":false,"before-upload":_vm.beforeAvatarUpload,"list-type":"picture-card","multiple":"","http-request":_vm.httpRequest}},[_c('i',{staticClass:"el-icon-plus avatar-uploader-icon"},[_vm._v("本地上传")])])
}
var staticRenderFns = []

export { render, staticRenderFns }